import { type Room } from 'livekit-client'

import { performRpc } from 'modules/ai_voice/lib/rpc'

let isObserverActive = false
let originalPushState: typeof history.pushState
let originalReplaceState: typeof history.replaceState
let handlePopState: () => void

export function registerRouteObserver(room: Room): void {
  async function notifyRouteChange(route: string) {
    await performRpc(room, 'routeChange', { route })
  }

  handlePopState = () => {
    notifyRouteChange(window.location.pathname)
  }

  window.addEventListener('popstate', handlePopState)

  originalPushState = history.pushState
  originalReplaceState = history.replaceState

  history.pushState = function (...args) {
    originalPushState.apply(history, args)
    notifyRouteChange(window.location.pathname)
  }

  history.replaceState = function (...args) {
    originalReplaceState.apply(history, args)
    notifyRouteChange(window.location.pathname)
  }

  isObserverActive = true
}

export function unregisterRouteObserver() {
  if (isObserverActive) {
    window.removeEventListener('popstate', handlePopState)
    history.pushState = originalPushState
    history.replaceState = originalReplaceState
    isObserverActive = false
  }
}
